/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

function getCookie(cookieName) {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }

  return null;  // Return null if the cookie doesn't exist
}

var cookiesarr = [
  "_uc_visits" , "_uc_utm_term" , "_uc_utm_campaign" , "_uc_utm_source",
  "_uc_current_session" , "_uc_utm_medium" , "_uc_utm_content" , "_uc_last_referrer", "_uc_initial_landing_page" , "_uc_referrer","growSumoPartnerKey"
];




var html = "";
cookiesarr.forEach(myFunction);
function myFunction(value, index, array) {
  const myCookieValue = getCookie(value);
  console.log("Cookie value:", myCookieValue);
  if(myCookieValue != "" && myCookieValue != null)
      html += '<input  type="hidden" name="attributes['+value+']" value="'+myCookieValue+'">';
  else
     html += '<input  type="hidden" name="attributes['+value+']" value="N/A">';
}


function findElementByClassWithTimer(className, timeout) {
  const intervalTime = 1000; // Check every 1 second
  let elapsedTime = 0;

  return new Promise((resolve, reject) => {
    const intervalId = setInterval(() => {
      elapsedTime += intervalTime;
      const elements = document.getElementsByClassName(className);

      if (elements.length > 0) {
        // Class found, clear the interval and resolve with the first element
        clearInterval(intervalId);
        resolve(elements[0]);
      }

      if (elapsedTime >= timeout) {
        // Timeout reached, clear the interval and reject
        clearInterval(intervalId);
        reject(new Error('Timeout: Class not found within the specified timeout.'));
      }
    }, intervalTime);
  });
}

// Example usage
const classNameToFind = 'hidden_notes';
const timeout = 100000000; // 1 seconds timeout

findElementByClassWithTimer(classNameToFind, timeout)
  .then((foundElement) => {
    console.log('Class found:', foundElement);
    const elements = document.getElementsByClassName('hidden_notes');

      for (let i = 0; i < elements.length; i++) {
        elements[i].innerHTML = html;
      }
  })
  .catch((error) => {
    console.log(error.message);
  });
